module.exports = __webpack_public_path__ + "assets/img/btn-view-ed292519.png";